var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2003 22.5002C46.5003 46.6002 4.60032 56.2002 0.100325 22.5002C-0.0996753 -1.59978 41.7003 -11.1998 46.2003 22.5002Z",
    fill: "#A8C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1004 17.6996C27.6004 18.1996 22.5005 23.0996 22.0005 23.4996C15.8005 29.3996 15.8005 29.3997 15.8005 29.3997C15.7005 29.4997 15.1005 30.3996 13.9005 31.1996C13.3005 31.5996 12.3004 32.1996 12.1004 31.9996C11.8004 31.6996 13.1004 30.0996 14.2004 28.7996C16.1004 26.5996 19.6005 22.6996 26.4005 16.0996",
    fill: "#E6EDE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1004 17.6996C27.6004 18.1996 22.5005 23.0996 22.0005 23.4996C15.8005 29.3996 15.8005 29.3997 15.8005 29.3997C15.7005 29.4997 15.1005 30.3996 13.9005 31.1996C13.3005 31.5996 12.3004 32.1996 12.1004 31.9996C11.8004 31.6996 13.1004 30.0996 14.2004 28.7996C16.1004 26.5996 19.6005 22.6996 26.4005 16.0996",
    stroke: "#FFFFFF",
    strokeWidth: 1.0822,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6006 14.5992C27.6006 14.0992 28.5006 13.5992 28.6006 13.5992C29.4006 13.2992 30.6006 13.0992 31.1006 13.7992C31.7006 14.6992 30.4006 16.6992 29.6006 16.5992C29.3006 16.5992 29.3006 16.2992 28.6006 15.5992C27.9006 14.9992 27.6006 14.8992 27.6006 14.5992Z",
    fill: "#E6EDE4",
    stroke: "#FFFFFF",
    strokeWidth: 1.1425,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bd5662c3d8d3f7e26bb0443f26b9df8e.svg";
export { ForwardRef as ReactComponent };